// extracted by mini-css-extract-plugin
export default {"list":"list-yqPU9P","item":"item-LXvBxa","icon":"icon-MGOSJd","content":"content-AM_P5i","title":"title-yfpW3F","desc":"desc-_fLskz"};